module.exports = __webpack_public_path__ + "img/202106.705855be.png";